<div
    class="{{
        'tw-flex t tw-rounded-lg  tw-pl-[1.2rem] tw-pr-[1rem] tw-py-2 tw-pb-[0.8rem] tw-flex-col tw-bg-white tw-w-[100%]' +
            (errors.length > 0
                ? ' tw-border-2 tw-border-primary-orange '
                : ' tw-border-b-[1px] tw-border-b-gray-200 ') +
            (classOverrides !== null ? ' ' + classOverrides : '')
    }}"
>
    <label
        class="tw-text-xs tw-font-[500] tw-mb-[5px] tw-text-gray-900"
        *ngIf="label !== null"
        >{{ label }}

        <span class="tw-text-red-400" *ngIf="mandatoryField === true">*</span>
    </label>
    <div class="tw-flex tw-items-center tw-justify-between">
        <div *ngIf="phoneNoCodeLabel !== undefined; else normalInput">
            <input
                *ngIf="phoneNoCodeLabel !== undefined"
                class="tw-text-[21px] tw-text-gray-400 tw-bg-white tw-max-w-[40px] tw-font-semibold"
                value="{{ phoneNoCodeLabel }}"
                disabled
            />

            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                class="tw-text-[21px] tw-bg-white tw-ml-2 tw-text-black tw-font-semibold"
                placeholder="{{ placeHolder }}"
            />
        </div>

        <ng-template #normalInput>
            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                class="tw-text-[21px] tw-bg-white tw-text-black tw-font-semibold"
                placeholder="{{ placeHolder }}"
        /></ng-template>

        <mat-icon
            *ngIf="removeValue && currentValue.length > 0"
            class="placeholder tw-mt-[-17px] tw-cursor-pointer"
            (click)="removeValueHandler()"
            >cancel</mat-icon
        >

        <mat-icon
            *ngIf="hideInput"
            class="placeholder tw-cursor-pointer"
            [ngStyle]="{
                'margin-top': label === null ? '-5px' : '-17px'
            }"
            (click)="toggleHideInput()"
            >{{ hide ? "visibility_off" : "visibility" }}</mat-icon
        >
    </div>
</div>

<div *ngIf="errors.length > 0" class="tw-flex tw-flex-col tw-mt-4">
    <div
        *ngFor="let error of errors; let i = index"
        class="tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
    >
        <mat-icon class="error-icon !tw-overflow-visible"
            >error_outline</mat-icon
        >

        <span
            [ngClass]="{
                'tw-border-b tw-pt-3 tw-pb-3 tw-border-gray-200':
                    i !== errors.length - 1
            }"
            >{{ error }}</span
        >
    </div>
</div>

<div *ngIf="strength !== null" class="tw-flex tw-mt-4 tw-gap-4">
    <div
        *ngFor="let no of strengthArray; let i = index"
        class="tw-bg-white tw-h-[4px] tw-flex-1 tw-rounded-[3rem]"
        [ngStyle]="{
            'background-color': i < strength ? strengthColor : 'transparent'
        }"
    ></div>
</div>

<div
    class="tw-text-right tw-mt-2 tw-text-gray-500"
    *ngIf="strengthLabel !== null"
>
    {{ strengthLabel }}
</div>
